<template>
	<div>
	  	<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">{{ title }}</h1>
			<login-form :return-url="returnUrl" :by-order="byOrder"></login-form>
	  	</div>
	  	<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import LoginForm from './components/LoginForm';
	import BaseNavLinks from './components/BaseNavLinks';

	export default {
		name: 'LoginPage',

		components: {
			LoginForm,
			BaseNavLinks,
		},

		props: {
			title: {
				type: String,
				default: 'Please log in to continue',
			},
			returnUrl: {
				type: String,
				default: '/help',
			},
			byOrder: {
				type: Boolean,
				default: true,
			},
		},
	}
</script>

<style scoped>

</style>